import { cn } from '@/lib/utils';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  load: any;
}

export const GeneralHeading: FC<IProps> = ({ load }) => {
  const { t } = useTranslation();

  return (
    <div className="flex-h-center-between">
      <div className="flex items-center gap-4">
        <p className="text-xl font-medium">
          {t('id.number')}:
          <span className={cn(load?.number ? 'text-green-500' : '', 'ml-2')}>
            {load?.number ? load?.number : '----'}
          </span>
        </p>
      </div>
    </div>
  );
};
